// Compact Baht formatter, e.g. ฿4.1M / ฿18K / ฿0, matching the dashboard design.
const compactBaht = baht => {
  const v = Number(baht) || 0
  if (v >= 1e6) return `฿${Math.round(v / 1e5) / 10}M`
  if (v >= 1e3) return `฿${Math.round(v / 1e3)}K`
  return `฿${Math.round(v)}`
}

// Holdings/performance metrics arrive in satangs (THB cents).
export const compactBahtFromSatangs = satangs => compactBaht((Number(satangs) || 0) / 100)

// Money.value is already in Baht (derived from order totals).
export const compactBahtFromValue = value => compactBaht(value)

// CompanyProject.status enum -> Thai label + Tag color.
export const PROJECT_STATUS_LABELS = {
  quotation: 'เสนอราคา',
  in_progress: 'กำลังดำเนินการ',
  completed: 'เสร็จสิ้น'
}

export const PROJECT_STATUS_COLORS = {
  quotation: 'gold',
  in_progress: 'blue',
  completed: 'green'
}

// updateCustomer.errors is a JSON-encoded string (null when there's no error),
// e.g. '{"base":["..."]}' or '["..."]'. Flatten it into a human-readable line
// for antd's message.error instead of showing the raw JSON.
export const formatMutationErrors = errors => {
  if (!errors) return ''
  let parsed
  try {
    parsed = JSON.parse(errors)
  } catch (e) {
    return String(errors)
  }
  if (Array.isArray(parsed)) return parsed.join(', ')
  if (parsed && typeof parsed === 'object') {
    return Object.entries(parsed)
      .map(([field, msgs]) => [].concat(msgs).join(', '))
      .filter(Boolean)
      .join(' · ')
  }
  return String(parsed)
}
